import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { DoxMascot } from "@/components/Logo";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen bg-ink flex flex-col items-center justify-center gap-4">
        <div className="animate-float"><DoxMascot size={64} /></div>
        <p className="text-white/40 text-sm">DOX is getting things ready…</p>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}
